export default __webpack_public_path__ + "static/media/chickenLoading.345c3ef7.gif";